import { CHIP_SIZE, CHIP_TYPE, Chip, Switch } from '@repo/design-system/index'
import { QIcon_chevron_bold_right } from '@repo/icons/index'
import { useEffect, useState } from 'react'
import apis from '../../../../modules/apis'
import { axiosPost } from '../../../../modules/axiosHelper'
import { n_common, n_tutors } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'
import Graph from './Graph'
import ReviewItem from './ReviewItem'

const SummaryPanel = ({ data, setActiveTab }) => {
  const { t, isLocaleKO } = useTranslation()
  const intro_myself = data?.intro?.find((e) => e.title === 'More about myself') || ''

  const [introContent, setIntroContent] = useState('')
  const [showKorean, setShowKorean] = useState(false)

  useEffect(() => {
    if (intro_myself && !showKorean) {
      setIntroContent(intro_myself?.content)
    }
  }, [intro_myself, showKorean])

  useEffect(() => {
    if (introContent && showKorean) {
      triggerChange(introContent)
    }
  }, [showKorean])

  const triggerChange = async (content) => {
    const response = await axiosPost(apis.googleTranslate(), {
      text: content,
      mode: 'en_ko',
    })
    if (response.success) {
      setIntroContent(response.translated)
    } else {
      alert(response.message)
    }
  }

  if (!data) return null
  return (
    <div>
      <div className="Title1-20Bd">{t(n_tutors.keywords)}</div>
      <div className="mt-[16px]">
        {/* 핵심 경험 */}
        {data.experiences.length > 0 && (
          <div className="flex flex-col">
            <div className="Body1-16Bd text-gray-600">{t(n_tutors.experience)}</div>
            <div className="mt-[8px] flex flex-wrap gap-[4px] sm:gap-x-[8px]">
              {data.experiences.map((item, i) => (
                <Chip customBgColor={COLORS.GRAY100} key={`item-${i}`} type={CHIP_TYPE.ACTIONABLE} size={CHIP_SIZE.MD}>
                  <Chip.Label customTxtColor={COLORS.GRAY700}>{item}</Chip.Label>
                </Chip>
              ))}
            </div>
          </div>
        )}
        {/* 관심사 */}
        {data.interests.length > 0 && (
          <div className="mt-[16px] flex flex-col">
            <div className="Body1-16Bd text-gray-600">{t(n_tutors.interests)}</div>
            <div className="mt-[8px] flex flex-wrap gap-[4px] sm:gap-x-[8px]">
              {data.interests.map((item, i) => (
                <Chip customBgColor={COLORS.GRAY100} key={`item-${i}`} type={CHIP_TYPE.ACTIONABLE} size={CHIP_SIZE.MD}>
                  <Chip.Label customTxtColor={COLORS.GRAY700}>{item}</Chip.Label>
                </Chip>
              ))}
            </div>
          </div>
        )}
        <div className="mt-[48px]">
          <div className="flex items-center justify-between">
            <div className="Title1-20Bd">{intro_myself?.title}</div>
            {isLocaleKO && (
              <div className="">
                <div className="flex flex-row items-center">
                  <span className="Body2-14Md mr-[8px] text-gray-500">한글로 보기</span>
                  <Switch checked={showKorean} setChecked={setShowKorean} />
                </div>
              </div>
            )}
          </div>
          <div className="Body1-16Md my-[8px] text-gray-700">{introContent}</div>
          <div className="flex cursor-pointer items-center" onClick={() => setActiveTab(1)}>
            <div className="Body2-14Bd sm:Body1-16Bd text-purple-500">{t(n_common.btn_more)}</div>
            <QIcon_chevron_bold_right color={COLORS.PURPLE500} width={16} height={16} className="mb-[3px]" />
          </div>
        </div>
        {data.main_evaluation_keywords?.length > 0 && (
          <div className="mt-[48px]">
            <div className="flex items-center justify-between">
              <div className="Title1-20Bd">{t(n_tutors.review)}</div>
              <div className="flex cursor-pointer items-center" onClick={() => setActiveTab(2)}>
                <div className="Body2-14Bd sm:Body1-16Bd text-purple-500">{t(n_common.btn_more)}</div>
                <QIcon_chevron_bold_right color={COLORS.PURPLE500} width={16} height={16} />
              </div>
            </div>
            <div className="mt-[16px]">
              {data.main_evaluation_keywords?.map((item, i) => (
                <Graph key={i} proportion={item.proportion} keyword={item.keyword} />
              ))}
            </div>
            <div className="Body2-14Md mt-16 text-gray-500">{t(n_tutors.review_explanation)}</div>
          </div>
        )}
        <div className="mt-[16px] h-[1px] w-full bg-gray-200"></div>
        <div className="divide-y-1  mt-[16px] flex flex-col divide-gray-200">
          {data.reviews?.length > 0 &&
            data?.reviews
              .filter((item) => item.comment)
              .slice(0, 3)
              ?.map((item, i) => <ReviewItem key={`item-${i}`} item={item} i={i} />)}
        </div>
      </div>
    </div>
  )
}

export default SummaryPanel
